import getAttr from '../../../utils/getAttr'

/**
 * Actions factory.
 *
 * @param {FetchPath} fetchPath
 * @param {Function} requireAuthentication
 * @return {{xhrIndexSalesNegotiationLines({commit: Function}, {orderId: number}): Promise, xhrIndex({dispatch: Function}, {order: Object}): Promise, xhrIndexSalesOrderLines({commit: Function}, {orderId: string}): Promise}}
 */
export default ({ fetchPath, requireAuthentication }) => ({
  /**
   * Index order lines.
   *
   * @param {Function} dispatch
   * @param {Object} order
   * @return {Promise}
   */
  xhrIndex({ dispatch }, { order }) {
    const orderType = getAttr('type', order)

    if (orderType === 'negotiation') {
      return dispatch('xhrIndexSalesNegotiationLines', { orderId: getAttr('id', order) })
    }
    if (orderType === 'order') {
      return dispatch('xhrIndexSalesOrderLines', { orderId: getAttr('id', order) })
    }

    throw new Error(`Unknown order type '${orderType}' received`)
  },

  /**
   * Index sales negotiation lines.
   *
   * @param {Function} commit
   * @param {Object} rootState
   * @param {number} orderId
   * @return {Promise}
   */
  async xhrIndexSalesNegotiationLines({ commit, rootState }, { orderId }) {
    requireAuthentication({ rootState })

    commit('SET_LOADING', true)

    const lines = await fetchPath.run({
      path: '/yoda/api/sales-negotiation-lines',
      jsonPath: ['content', 'data'],
      parameters: { salesNegotiation: orderId, itemsPerPage: 999 },
    })

    commit('SET_ENTITIES', lines)
    commit('SET_LOADING', false)

    return lines
  },

  /**
   * Index sales order lines.
   *
   * @param {Function} commit
   * @param {Object} rootState
   * @param {string} orderId
   * @return {Promise}
   */
  async xhrIndexSalesOrderLines({ commit, rootState }, { orderId }) {
    requireAuthentication({ rootState })

    commit('SET_LOADING', true)

    const lines = await fetchPath.run({
      path: '/yoda/api/sales-order-lines',
      jsonPath: ['content', 'data'],
      parameters: { salesOrder: orderId, itemsPerPage: 999 },
    })

    commit('SET_ENTITIES', lines)
    commit('SET_LOADING', false)

    return lines
  },
})
